import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=2cc894f2&scoped=true&"
import script from "./Heart.vue?vue&type=script&lang=js&"
export * from "./Heart.vue?vue&type=script&lang=js&"
import style0 from "./Heart.vue?vue&type=style&index=0&id=2cc894f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc894f2",
  null
  
)

export default component.exports